import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getHeight, getWidth } from '../../../utils/relativeSizes'
import { getIsTimeBankVisible, getTimeBankTimeLeft, getTotalTimeBankTime } from '../../../store/selectors/ludoboardSelectors'
import { updateTimeBankTimeLeft } from '../../../store/actions/ludoboardActions'
import { _isNil } from '../../../utils/helpers/zupeeLodash'
import { NX_TIMER_TYPES } from '../../../pages/GamePlay/types'
import { useTranslation } from 'react-i18next'
import TimerCircularAnimation from '../TimerCircularAnimation/TimerCircularAnimation'
import clsx from 'clsx';
import styles from "./styles.module.css";

function TimeBank() {
  const { t } = useTranslation()
  const timeBankTimeLeft = useSelector(getTimeBankTimeLeft)
  const totalTimeBankTime = useSelector(getTotalTimeBankTime)
  const isTimeBankVisible = useSelector(getIsTimeBankVisible)
  const [timeLeft, setTimeLeft] = useState(timeBankTimeLeft)
  const counterInterval = useRef<ReturnType<typeof setInterval> | null>(null)

  const timeLeftRef = useRef(timeLeft)

  useEffect(() => {
    if (isTimeBankVisible) {
      setTimeLeft(timeBankTimeLeft)
      if (counterInterval.current) {
        clearInterval(counterInterval.current)
      }
      counterInterval.current = setInterval(() => {
        setTimeLeft(curr => {
          timeLeftRef.current = curr - 1
          return curr - 1
        })
      }, 1000)

      return () => {
        updateTimeBankTimeLeft(timeLeftRef.current)
        if (counterInterval.current) {
          clearInterval(counterInterval.current)
        }
      }
    }
  }, [timeBankTimeLeft, isTimeBankVisible])

  const timeBankConfig = useMemo(() => {
    if (timeLeft > totalTimeBankTime - 2) {
      return {
        timerText: t("extraTime"),
        timerType: NX_TIMER_TYPES.BANK_SMALL
      }
    }
    if (timeLeft > 10) {
      return {
        timerText: t("extraTimeExhausting"),
        timerType: NX_TIMER_TYPES.BANK_LARGE
      }
    }
    return {
      timerText: t("extraTimeCarefull"),
      timerType: NX_TIMER_TYPES.BANK_LARGE
    }
  }, [timeLeft])

  if (!isTimeBankVisible || timeLeft < 0 || _isNil(timeBankConfig)) {
    return null
  }

  return (
    <div
      style={{
        bottom: '20vh',
        position: 'absolute',
        height: getHeight(26),
        backgroundColor: '#101D49',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: getWidth(45),
        paddingRight: getWidth(22),
        borderRadius: 45,
        transform: 'translate(-50%, 0%)',
        left: '50%'
      }}>
      <div
        style={{
          position: 'absolute',
          left: getWidth(-4),
          height: getWidth(45),
          width: getWidth(45),
          borderRadius: 45,
          backgroundColor: '#101D49',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <TimerCircularAnimation
          resetTimer={1}
          timeLeft={timeBankTimeLeft}
          totalTurnTime={totalTimeBankTime}
          percentageToChangeColorFrom={(totalTimeBankTime - 10) / totalTimeBankTime}
          timerType={timeBankConfig.timerType}
        />

        <div className={clsx(styles.timeLeftText, "fontWeight700 fontSizeSm14 fontColorWhite")}>{timeLeft}</div>
      </div>
      <div className={clsx(styles.timeText, "fontWeight700 fontSizeXs fontColorWhite")}>{timeBankConfig.timerText}</div>
    </div>
  )
}

export default TimeBank;
